<sf-card cardTitle="Parts Arena Diagram">
    <p class="text-body-secondary">
        View parts arena diagram for a specific appliance model by searching a GC Number or finding by manufacturer and
        product type.
    </p>
    <div class="row">
        <div class="col-md-3">
            <sf-input-phone
                [mask]="'00-000-00'"
                label="GC Number"
                inputId="gcnumber"
                [formControl]="gcNumberSearch"
                buttonLabel="Search"
                (buttonClick)="searchByGcNumber()"></sf-input-phone>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <sf-label for="manufacturer" label="Manufacturer"></sf-label>
            <ng-select
                id="manufacturer"
                placeholder="Select Manuafacturer"
                (change)="selectManufacturer($event)"
                [items]="manufacturers()"
                [(ngModel)]="manufacturerId"
                [clearable]="false"
                appendTo="body"
                groupBy="featured"
                bindLabel="description"
                bindValue="manufacturerId">
                <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.featured ? 'Featured' : 'All Manufacturers' }}
                </ng-template>
            </ng-select>
        </div>
        <div class="col-md-3">
            <sf-label for="producttype" label="Product Type"></sf-label>
            <ng-select
                id="producttype"
                placeholder="select product type"
                (change)="selectProductType($event)"
                [readonly]="!manufacturerId()"
                [items]="productTypes.value()!"
                [clearable]="false"
                appendTo="body"
                [(ngModel)]="productTypeId"
                bindLabel="display"
                bindValue="id">
            </ng-select>
        </div>
        <div class="col-md-3">
            <sf-label for="productrange" label="Product Range"></sf-label>
            <ng-select
                id="productrange"
                placeholder="select product range"
                (change)="selectProductRange($event)"
                [readonly]="!productTypeId()"
                [items]="productRanges.value()!"
                [clearable]="false"
                appendTo="body"
                [(ngModel)]="productRangeId"
                bindLabel="display"
                bindValue="id">
            </ng-select>
        </div>
        <div class="col-md-3">
            <sf-label for="model" label="Model"></sf-label>
            <ng-select
                id="model"
                placeholder="select model"
                (change)="selectModel($event)"
                [readonly]="!productRangeId()"
                [items]="models.value()!"
                [clearable]="false"
                appendTo="body"
                [(ngModel)]="modelId"
                bindLabel="description"
                bindValue="modelId">
            </ng-select>
        </div>
    </div>
</sf-card>

<sf-card [hidden]="!modelId()">
    <div class="row">
        <div class="col-12 mb-3">
            <div class="scroll-container">
                @for (item of partList.value(); track item.partslistSectionId + item.description) {
                    <button
                        sfButton
                        type="button"
                        size="md"
                        color="primary"
                        [active]="selectedPartListId() == item.partslistSectionId"
                        (click)="selectPartList(item)">
                        {{ item.description }}
                    </button>
                }
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-md-4">
                    <sf-input
                        placeholder="Search part (e.g. fan, clip, washer etc)"
                        label="Search from {{ sections.value()?.length }} Parts"
                        [formControl]="partFilter"></sf-input>
                    <div ngbScrollSpy #spy="ngbScrollSpy" class="list-group" style="height: 500px; overflow-y: auto">
                        @for (item of sectionRowsFiltered(); track item.partslistSectionRowId + item.catalogNumber) {
                            <li
                                [ngbScrollSpyFragment]="item.itemNumber || item.partslistSectionRowId.toString()"
                                [class.active]="hoveredPart()?.itemNumber == item.itemNumber"
                                role="button"
                                class="list-group-item list-group-item-action">
                                <div>
                                    <div class="d-flex justify-content-between">
                                        <div class="fw-bold">
                                            {{ item.itemNumber }}. {{ item.description }} ({{ item.partId }})
                                        </div>
                                        @if (showWolseleyOrderButtons && item.catalogNumber !== '') {
                                            <button
                                                sfButton
                                                type="button"
                                                size="sm"
                                                color="secondary"
                                                (click)="handleWolseleyOrderButtonClick(item.catalogNumber)">
                                                Order
                                            </button>
                                        }
                                    </div>
                                    <p class="small mb-0">
                                        <b>Catalog Number:</b> {{ item.catalogNumber }}<br />
                                        <b>GC Number:</b> {{ item.gcNumber }}<br />
                                        <b>MPN:</b> {{ item.manufacturerPartNumber }}<br />
                                        <b>Trade:</b> {{ item.trade }}<br />
                                        <b>Net:</b> {{ item.net }}<br />
                                        <b>Status:</b> {{ item.status }}<br />
                                    </p>
                                </div>
                            </li>
                        }
                    </div>
                </div>
                <div class="col-md-8">
                    <div #imgContainer class="image-container border border-1 border-body-secondary">
                        @if (imageUrl()) {
                            <img [src]="imageUrl()" class="img-fluid" />
                        }

                        @for (hotspot of hotspots(); track hotspot.number + hotspot.posY1) {
                            <div
                                class="image-hotspot"
                                container="body"
                                [ngbPopover]="popContent"
                                [popoverTitle]="popTitle"
                                [popoverContext]="{ part: hoveredPart() }"
                                triggers="mouseenter:mouseleave"
                                (mouseenter)="onHotspotEnter(hotspot.number); spy.scrollTo(hotspot.number.toString())"
                                (hidden)="onHotspotLeave()"
                                [style.left.px]="hotspot.posX1 - 5"
                                [style.top.px]="hotspot.posY1 - 5"
                                [style.width.px]="hotspot.posX2 - hotspot.posX1 + 5"
                                [style.height.px]="hotspot.posY2 - hotspot.posY1 + 5"></div>
                        }
                    </div>

                    <ng-template #popTitle let-part="part"> {{ part.itemNumber }}. {{ part.description }} </ng-template>
                    <ng-template #popContent let-part="part">
                        <p>
                            <b>Catalog Number:</b> {{ part.catalogNumber }}<br />
                            <b>GC Number:</b> {{ part.gcNumber }}<br />
                            <b>MPN:</b> {{ part.manufacturerPartNumber }}<br />
                            <b>Trade:</b> {{ part.trade }}<br />
                            <b>Net:</b> {{ part.net }}<br />
                            <b>Status:</b> {{ part.status }}<br />
                        </p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</sf-card>
